export default __webpack_public_path__ + "../img/cd2157fb119b867ca4dc49706da682a8.gif";